import { ChangeDetectionStrategy, Component, HostBinding, ViewEncapsulation } from '@angular/core';

import { Observable, map } from 'rxjs';

import { ExtendedAutoSuggestions } from '@hdms/shared/page-frame/data-access';

import { SearchResultsComponentAbstract } from '../search-results-component.abstract';

@Component({
  selector: 'shrd-pf-ft-search-products',
  templateUrl: './search-products.component.html',
  styleUrls: ['./search-products.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class SearchProductsComponent extends SearchResultsComponentAbstract {
  readonly suggestions$ = this.getProducts$();

  @HostBinding('class.shrd-pf-ft-search-products') private readonly hostClass = true;

  private getProducts$(): Observable<ExtendedAutoSuggestions> {
    return this.getSuggestions$().pipe(map(suggestions => suggestions.products?.length && suggestions));
  }
}
